<template>
  <modal @send="complete" @complete="complete" @escape="exit" class="notice-for-add">
    <div slot="header" class="emphasize margin-bottom-x2">Notice！</div>
    <div slot="body">
      <div class="desc margin-bottom-x2">
        Once the nominee is added successfully, the details cannot be amended. Hence, please check that the information entered is accurate before clicking
        <b>Add.</b>
      </div>
      <div class="margin-bottom-x2">
        <ttw-button class="w-100" @click="complete" value="I got it！" />
      </div>
      <checkbox label="Don't show again." :value="true" v-model="status"></checkbox>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/layout/Modal";
export default {
  inheritAttrs: false,
  name: "notice-for-add",
  extends: Modal,
  components: {
    Modal
  },
  data() {
    return {
      status: false
    };
  },
  methods: {
    complete() {
      this.$emit("complete", this.status);
    },
    exit() {
      this.$emit("escape");
    }
  }
};
</script>
<style lang="scss" scoped>
.notice-for-add {
  .desc {
    line-height: 2;
  }
}
</style>